import React from 'react';
import ErrorBlock from '../components/ErrorBlock';

const ErrorPage = () => {
  return <ErrorBlock />;
};

export default ErrorPage;
